import { FeaturedProductResponseDto } from '../dto/featuredproducts.dto';
import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

class FeaturedProductService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getFeaturedProducts(): Promise<FeaturedProductResponseDto> {
    return this.__Apiservice.getRequest('products/featured', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

// Create an instance of the service
const featuredProductService = new FeaturedProductService();

export default featuredProductService;